const BASE = "/api/data.php";

const EXCLUDE = ["rc_user"];

async function post(action: string, payload: any) {
  try {
    const res = await fetch(`${BASE}?action=${action}`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
    return await res.json();
  } catch {
    return null;
  }
}

async function get(action: string, params = "") {
  try {
    const res = await fetch(`${BASE}?action=${action}${params}`, { credentials: "include" });
    return await res.json();
  } catch {
    return null;
  }
}

export async function saveRecord(store_type: string, data: string, user: any) {
  return post("save_record", { store_type, record_id: "snapshot", data, updated_by: (user && user.name) || "system" });
}

export async function logAudit(user: any, action: string, entity_type: string, entity_id = "", detail = "") {
  return post("audit", { user_name: (user && user.name) || "", user_role: (user && user.role) || "", action, entity_type, entity_id, detail });
}

export async function getAudit(limit = 500) {
  return get("get_audit", `&limit=${limit}`);
}

export async function restoreFromBackend() {
  const rows = await get("get_all_snapshots");
  if (!Array.isArray(rows)) return;
  rows.forEach((row: any) => {
    if (!row.store_type || row.data == null) return;
    if (EXCLUDE.includes(row.store_type)) return;
    if (!localStorage.getItem(row.store_type)) {
      try { localStorage.setItem(row.store_type, row.data); } catch {}
    }
  });
}

const lastSync: Record<string, string> = {};

export async function syncAllToBackend(user: any) {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key || EXCLUDE.includes(key)) continue;
    const data = localStorage.getItem(key);
    if (data === null || data.length > 2000000) continue;
    if (lastSync[key] === data) continue;
    const ok = await saveRecord(key, data, user);
    if (ok && ok.ok) {
      if (lastSync[key] !== undefined) logAudit(user, "UPDATE", key, "", "Data synced to secure backend");
      lastSync[key] = data;
    }
  }
}